import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppBar } from '../../components/appBar/appBarContext';
import { changeRouteType } from '../../redux/handleBackBtn/handleBackBtnSlice';

export default function WaitForBank() {
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        setHeader('ثبت چک ضمانت', 'Accept')
    }, []);

    return (
        <div style={{ textAlign: 'center' }}>
            <img
                src="images/accept.svg"
                style={{ display: 'inline-block' }}
                className="mt-10"
            />
            <Typography className=" !mt-12 !font-bold secondaryColorLight-600">
                <div>
                    درخواست شما با <span className="secondaryColorLight-600">موفقیت</span> ثبت شده است.

                </div>
                <div>
                    در انتظار ارسال به بانک می‌باشد
                </div>

            </Typography>
        </div>
    );
}
